import { useState } from 'react';

export const useCollapsibleList = <T>(items: T[], maxRows = 5) => {
  const [isShowAll, setIsShowAll] = useState(false);
  const isCollapsible = items.length > maxRows;

  return {
    itemList: isShowAll ? items : items.slice(0, maxRows),
    isCollapsed: isCollapsible && isShowAll === false,
    showAllItems: () => setIsShowAll(true),
  };
};
